let url = 'https://api.venu.ai';
let imagesAmazonS3URL = 'https://storage.googleapis.com/media.main.venu.ai';
let navType = 'deployed';
export {url , imagesAmazonS3URL, navType};
